import { Parser } from './internal/Parser.mjs';
import { Serializer } from './internal/Serializer.mjs';

class FqlUtilities {
  static parse(query) {
    if (typeof query !== 'string') {
      throw new TypeError('QUERY_MUST_BE_STRING');
    }
    return Parser.parse(query);
  }

  static serialize(query) {
    return Serializer.serialize(query);
  }
}

export { FqlUtilities };
export default FqlUtilities;
